// import React, { useEffect, useMemo, useState } from 'react';
// import { CustomGridLayout } from '../Cards/CustomCard';

// export default function CustomTabGroup({ name, onChange, tabs, className, data, value, col = 12, options = [], optionLabel = 'name' }) {
//     const [activeButton, setActiveButton] = useState(null);

//     return (
//         <>
//             <CustomGridLayout>
//                 <div className="flex gap-3">
//                     {tabs?.map((tab, index) => (
//                         <div
//                             onClick={() => setActiveButton(index)}
//                             className={`cursor-pointer border-round-lg text-sm  px-4 py-2
//                                 ${activeButton === index ? 'btn-dark' : 'bg-white text-black'}`}
//                         >
//                             {tab.name}
//                         </div>
//                     ))}
//                 </div>
//             </CustomGridLayout>
//         </>
//     );
// }

import React, { useState } from 'react';
import { CustomGridLayout } from '../Cards/CustomCard';

export default function CustomTabGroup({ name, onChange, tabs, data }) {
    const [activeButton, setActiveButton] = useState(0);

    const handleTabClick = (index) => {
        setActiveButton(index);

        const updatedData = {
            ...data,
            [name]: tabs[index].value,
        };

        if (onChange) {
            onChange(updatedData);
        }
    };

    return (
        <CustomGridLayout>
            <div className="flex gap-3">
                {tabs?.map((tab, index) => (
                    <div
                        key={index}
                        onClick={() => handleTabClick(index)}
                        className={`cursor-pointer border-round-lg text-sm px-4 py-2
                        ${activeButton === index ? 'btn-dark' : 'bg-white text-black'}`}
                    >
                        {tab.name}
                    </div>
                ))}
            </div>
        </CustomGridLayout>
    );
}
